export const actionKey = '@@APP';
